<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        border-variant="dark"
        class="main-card"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row>
          <b-col>
            <h5>
              <i class="fas fa-user-cog"></i> ตั้งค่าบัญชีผู้ใช้
            </h5>
          </b-col>
        </b-row>
        <div class="w-100 mt-2 mb-3 border-bottom"></div>
        <b-row>
          <b-col>
            <h6 class="font-weight-bold">
              <i class="fas fa-user-circle"></i>
              จัดการโปรไฟล์
            </h6>
          </b-col>
        </b-row>
        <form
          accept-charset="utf-8"
          id="login"
          role="form"
          v-on:submit="saveProfile($event)"
        >
          <b-row>
            <b-col class="text-center">
              <label for="image" class="button-upload-file">
                <input
                  name="image"
                  id="image"
                  type="file"
                  class="custom-file-input"
                  accept="image/jpeg, image/jpg, image/png"
                />
                <div class="avatar-preview">
                  <img width="80" :src="require('@/assets/images/defaultPerson.jpeg')" />
                </div>
                <span class="icon text-white">
                  <i class="fas fa-camera"></i>
                </span>
              </label>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="mb-3">
              <label class="mb-1">
                <strong>ชื่อผู้ใช้งาน</strong>&nbsp;
                <small>Username</small>
              </label>
              <b-form-input readonly v-model="profile.username" required @blur="checkProfile"></b-form-input>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
              <label class="mb-1">
                <strong>ชื่อจริง</strong>
              </label>
              <b-form-input readonly v-model="profile.firstname" required @blur="checkProfile"></b-form-input>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
              <label class="mb-1">
                <strong>นามสกุล</strong>
              </label>
              <b-form-input  readonly v-model="profile.lastname" required @blur="checkProfile"></b-form-input>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
              <label class="mb-1">
                <strong>วันเดือนปีเกิด</strong>
              </label>
              <b-form-input type="date"  :readonly="!formState.isEditableProfile" v-model="profile.birthdate" required @blur="checkProfile"></b-form-input>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
              <label class="mb-1">
                <strong>อีเมล</strong>
              </label>
              <b-form-input type="email" :readonly="!formState.isEditableProfile" v-model="profile.email" required @blur="checkProfile"></b-form-input>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
              <label class="mb-1">
                <strong>เบอร์โทรศัพท์</strong>
              </label>
              <b-form-input readonly v-model="profile.mobile"></b-form-input>
            </b-col>
          </b-row>
          <b-row v-if="profile.errMessage !== null">
            <b-col>
              <b-alert variant="danger" show>{{profile.errMessage}}</b-alert>
            </b-col>
          </b-row>
          <b-row v-if="profile.successMessage !== null">
            <b-col>
              <b-alert variant="success" show>{{profile.successMessage}}</b-alert>
            </b-col>
          </b-row>
          <b-row v-if="formState.isEditableProfile">
            <b-col cols="12">
              <b-button
                variant="primary"
                block
                type="submit"
                :disabled="!formState.profileComplete"
              >
                <i class="fas fa-save"></i> บันทึก
              </b-button>
            </b-col>
          </b-row>
        </form>
        <div class="w-100 mt-3 mb-3 border-bottom"></div>
        <b-row class="mb-2">
          <b-col>
            <h6 class="font-weight-bold">
              <i class="fas fa-user-circle"></i>
              จัดการรหัสผ่าน
            </h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mb-3">
            <label class="mb-1">
              <strong>รหัสผ่านเดิม</strong>
            </label>
            <b-form-input
              type="password"
              v-model="password.current"
              :state="formState.currentPassword"
              aria-describedby="input-current-feedback"
              @blur="checkCurrentPassword"
            ></b-form-input>
            <b-form-invalid-feedback id="input-current-feedback">{{formErrors.current}}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" class="mb-3">
            <label class="mb-1">
              <strong>รหัสผ่านใหม่</strong>
            </label>
            <b-form-input
              type="password"
              v-model="password.new"
              :state="formState.newPassword"
              aria-describedby="input-new-feedback"
              @blur="checkNewPassword"
            ></b-form-input>
            <b-form-invalid-feedback id="input-new-feedback">{{formErrors.new}}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" class="mb-3">
            <label class="mb-1">
              <strong>ยืนยันรหัสผ่านใหม่</strong>
            </label>
            <b-form-input
              type="password"
              v-model="password.confirm"
              :state="formState.confirmPassword"
              aria-describedby="input-confirm-feedback"
              @blur="checkConfirmPassword"
            ></b-form-input>
            <b-form-invalid-feedback id="input-confirm-feedback">{{formErrors.confirm}}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row v-if="password.errMessage !== null">
          <b-col>
            <b-alert variant="danger" show>{{password.errMessage}}</b-alert>
          </b-col>
        </b-row>
        <b-row v-if="password.successMessage !== null">
          <b-col>
            <b-alert variant="success" show>{{password.successMessage}}</b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-button
              variant="primary"
              block
              :disabled="(formState.currentPassword && formState.newPassword && formState.confirmPassword) ? false : true"
              @click="changePassword"
            >
              <i class="fas fa-save"></i> บันทึก
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  name: 'Profile',
  props: ['page'],
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      profile: {
        username: null,
        firstname: null,
        lastname: null,
        birthdate: null,
        email: null,
        mobile: null,
        errMessage: null,
        successMessage: null
      },
      password: {
        current: null,
        new: null,
        confirm: null,
        errMessage: null,
        successMessage: null
      },
      formState: {
        currentPassword: null,
        newPassword: null,
        confirmPassword: null,
        isEditableProfile: false,
        profileComplete: false
      },
      formErrors: {
        current: null,
        new: null,
        confirm: null
      }
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    saveProfile(e) {
      e.preventDefault();
      this.profile.errMessage = null;
      this.profile.successMessage = null;
      axios.post(this.getApiUrl + "/customer/updateProfile",
        {
          username: this.getUsername,
          firstName: this.profile.firstname,
          lastName: this.profile.lastname,
          email: this.profile.email,
          dateOfBirth: this.profile.birthdate
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          console.log(response);
          if(response.data.statusCode == 200) {
            this.profile.successMessage = "บันทึกข้อมูลเรียบร้อยแล้ว";
            this.getProfile();
          }
          else {
            this.profile.errMessage = response.data.message;
          }
        });
    },
    getProfile() {
      this.profile.username = this.getUsername;
      axios.post(this.getApiUrl + "/customer/getcurrentfinance",
        {
          username: this.getUsername
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          console.log(response);
          if(response.data.statusCode == 200) {
            const userInfo = response.data.data;
            this.profile.firstname = userInfo.firstName;
            this.profile.lastname = userInfo.lastName;
            if(userInfo.dateOfBirth == "") {
              this.profile.birthdate = null;
            }
            else {
              this.profile.birthdate = moment(userInfo.dateOfBirth).format('YYYY-MM-DD');
            }
            this.profile.email = userInfo.email;
            this.profile.mobile = userInfo.mobile;
            this.formState.isEditableProfile = userInfo.isEditableProfile;
          }
          else {
            this.logout();
          }
        });
    },
    checkProfile() {
      this.formState.profileComplete = false;
      if(this.profile.firstname !== null && this.profile.lastname !== null && this.profile.birthdate !== null && this.profile.email !== null) {
        this.formState.profileComplete = true;
      }
    },
    changePassword() {
      axios.post(this.getApiUrl + "/customer/changePassword",
        {
          username: this.getUsername,
          oldPassword: this.password.current,
          newPassword: this.password.new
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          console.log(response);
          if(response.data.statusCode == 200) {
            this.password.successMessage = "เปลี่ยนรหัสเรียบร้อยแล้ว";
          }
          else {
            this.password.errMessage = response.data.message;
          }
        });
    },
    checkCurrentPassword() {
      if (this.password.current === null || this.password.current.lenght == 0) {
        this.formErrors.current = "กรุณากรอกรหัสผ่านเดิม";
        this.formState.currentPassword = false;
      } else {
        this.formState.currentPassword = true;
      }
    },
    checkNewPassword() {
      if (this.password.new === null || this.password.new.lenght == 0) {
        this.formErrors.new = "กรุณากรอกรหัสผ่านใหม่";
        this.formState.newPassword = false;
      } else {
        this.formState.newPassword = true;
      }
    },
    checkConfirmPassword() {
      if (this.password.confirm === null || this.password.confirm.lenght == 0) {
        this.formErrors.confirm = "กรุณายืนยันรหัสผ่าน";
        this.formState.confirmPassword = false;
      } else if (this.password.new != this.password.confirm) {
        this.formErrors.confirm = "รหัสผ่านใหม่ และ ยืนยันรหัสผ่านใหม่ ไม่ตรงกัน";
        this.formState.confirmPassword = false;
      } else {
        this.formState.confirmPassword = true;
      }
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.avatar-preview {
  border-radius: 50px;
  overflow: hidden;
  height: 80px;
  width: 80px;
}

.button-upload-file {
  position: relative;
  cursor: pointer;

  input {
    width: 1px;
    height: 1px;
    display: block;
    position: absolute;
    top: -100%;
    left: -100%;
  }

  .icon {
    height: 32px;
    width: 32px;
    background: #3b5898;
    position: absolute;
    z-index: 0;
    bottom: 0px;
    right: 0px;
    text-align: center;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    padding: 5px 0px 0px 1px;
  }
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.credit-balance {
  background-color: #d4edda !important;
  border-color: #c3e6cb;
  font-size: 30px;
  line-height: 40px;
  height: 48px;

  :focus {
    outline: none;
  }
}
</style>